module.exports = __webpack_public_path__ + "static/media/forever_tricolour_9.a521ac19.jpg";